import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import UserInformation from './UserInformation';
import UserPermission from './UserPermission';
import UserSettings from './UserSettings';

const UserDetails = (props) => {
    const {
        formValues, formErrors, handleFormSubmit, handleFormChange, handleUserTypeChange, handleCostingPermission, handleCompanyChange,
        companyName, Department, Company, handleDepartmentChange, departmentName, Designation, handleDesignationChange, designationName, userRole, handleUserRoleChange, UserRoleName, userReport, handleUserReportingChange, UserReportingName, setCompanyName, setDesignationName, setDepartmentName, setUserRoleName, setUserReportingName, setUserType, handlePermissionType, checkedPermissions,
        setCheckedPermissions, userTypedrp, userType, clearFormValues, Distributor, handleToggleChange, isChecked, setFormValues, isSubmit, isSubmiting, setFormErrors, loading
    } = props;

    const [permission, setPermission] = useState([{ value: '1', label: 'View All User Data' }, { value: '2', label: 'Special Discount' }])

    const [companyData, setCompanyData] = useState([])
    const [companyDrp, setCompanyDrp] = useState([])

    const [distributorData, setdistributorData] = useState([])
    const [distributorDrp, setdistributorDrp] = useState([])

    const [departmentData, setDepartmentData] = useState([])
    const [departmentDrp, setDepartmentDrp] = useState([])

    const [designationData, setDesignationData] = useState([])
    const [designationDrp, setDesignationDrp] = useState([])

    const [userRoleData, setUserRoleData] = useState([])
    const [userRoleDrp, setUserRoleDrp] = useState([])

    const [userReportData, setUserReportData] = useState([])
    const [userReportDrp, setUserReportDrp] = useState([])

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        if (Company && Company.length > 0) {
            const formattedData = formatCompanyrp(Company);
            setCompanyDrp(formattedData);
        }
    }, [Company, setCompanyDrp]);

    const formatCompanyrp = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.companyName,
            value: data?.id,
            params: "company"
        }));
        return te;
    };

    useEffect(() => {
        if (Distributor && Distributor.length > 0) setdistributorData(Distributor)
    }, [Distributor])

    useEffect(() => {
        if (distributorData && distributorData.length > 0) {
            const list = formatdistributor(distributorData?.filter(item => item?.isActive === true));
            setdistributorDrp(list);
        }
    }, [distributorData]);

    const memoizedSetCompanyName = useCallback(setCompanyName, []);

    useEffect(() => {
        if (formValues?.id && companyDrp && companyDrp.length > 0 && formValues.userType === 1) {
            const obj = companyDrp.find(el => el?.value === formValues?.userCompanyId);
            if (obj) {
                memoizedSetCompanyName(obj);
            }
        }
    }, [formValues?.id, formValues?.userCompanyId, formValues.userType, companyDrp, memoizedSetCompanyName]);

    useEffect(() => {
        if (formValues?.id && distributorDrp && distributorDrp.length > 0 && formValues.userType === 2) {
            const obj = distributorDrp.find(el => el?.value === formValues?.userCompanyId);
            if (obj) {
                memoizedSetCompanyName(obj);
            }
        }
    }, [formValues?.id, formValues?.userCompanyId, formValues.userType, distributorDrp, memoizedSetCompanyName]);

    const formatdistributor = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.distributorName,
            value: data?.id,
            params: "distributor"
        }));
        return te;
    };

    useEffect(() => {
        if (Department) setDepartmentData(Department)
    }, [Department])

    useEffect(() => {
        if (departmentData) {
            const list = formatDepartmentrp(departmentData);
            setDepartmentDrp(list);
        }

    }, [departmentData]);

    const formatDepartmentrp = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.departmentName,
            value: data?.id
        }));
        return te;
    };

    useEffect(() => {
        if (Designation) setDesignationData(Designation)
    }, [Designation])

    useEffect(() => {
        if (designationData) {
            const list = formatDesignation(designationData);
            setDesignationDrp(list);
        }
    }, [designationData]);

    const formatDesignation = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.designationName,
            value: data?.id
        }));
        return te;
    };

    //Role Dropdown Details
    useEffect(() => {
        if (userRole) setUserRoleData(userRole)
    }, [userRole])

    useEffect(() => {
        if (userRoleData) {
            const formattedList = formatUserRole(userRoleData);
            const filteredList = userType?.value === "2" ? formattedList.filter(item => item?.distributorRole) : formattedList.filter(item => !item?.distributorRole);
            setUserRoleDrp(filteredList);
            const roleObj = filteredList?.find((item) => item?.value === formValues?.roleId)
            if (roleObj) setUserRoleName(roleObj)
        }
    }, [userRoleData, userType]);

    const formatUserRole = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.name,
            value: data?.id,
            distributorRole: data?.onlyForDistributor
        }));
        return te;
    };

    //Reporting Dropdown Details
    useEffect(() => {
        if (userReport) setUserReportData(userReport)
    }, [userReport])

    useEffect(() => {
        if (userReportData) {
            const list = formatUserReport(userReportData);
            setUserReportDrp(list);
        }
    }, [userReportData]);

    const formatUserReport = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.firstName + ' ' + data?.lastName,
            value: data?.identityId
        }));
        return te;
    };

    //edit
    useEffect(() => {
        if (formValues?.designationId) {
            var designationValue = designationDrp.filter(function (item) {
                return item.value === formValues?.designationId;
            });

            if (designationValue) setDesignationName(designationValue[0]);
        }
    }, [designationDrp, formValues?.designationId])

    useEffect(() => {
        if (formValues?.departmentId) {
            var departmentValue = departmentDrp.filter(function (item) {
                return item.value === formValues?.departmentId;
            });
            if (departmentValue) setDepartmentName(departmentValue[0]);
        }
    }, [departmentDrp, formValues?.departmentId])

    useEffect(() => {
        if (formValues?.reportingTo) {
            var ReportValue = userReportDrp.filter(function (item) {
                return item.value === formValues?.reportingTo;
            });
            if (ReportValue) setUserReportingName(ReportValue[0]);
        }
    }, [userReportDrp, formValues?.reportingTo])

    return (
        <section className='user-add-sec'>
            <div className='row'>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className='card'>
                    <div className="workspace-tab-bar card-header">
                        <button type="button" className="workspace-tab active">
                            <i className="fas fa-file-alt"></i>
                            <span>General Information</span>
                        </button>
                    </div>
                    <div className="card-body">
                    <div className="user-form-panel">
                        <UserInformation
                            userTypedrp={userTypedrp}
                            userType={userType}
                            formErrors={formErrors}
                            formValues={formValues}
                            handleFormChange={handleFormChange}
                            showPassword={showPassword}
                            showConfirmPassword={showConfirmPassword}
                            userRoleDrp={userRoleDrp}
                            handleUserRoleChange={handleUserRoleChange}
                            UserRoleName={UserRoleName}
                            distributorDrp={distributorDrp}
                            companyDrp={companyDrp}
                            handleCompanyChange={handleCompanyChange}
                            companyName={companyName}
                            departmentDrp={departmentDrp}
                            handleDepartmentChange={handleDepartmentChange}
                            departmentName={departmentName}
                            designationDrp={designationDrp}
                            handleDesignationChange={handleDesignationChange}
                            designationName={designationName}
                            userReportDrp={userReportDrp}
                            handleUserReportingChange={handleUserReportingChange}
                            UserReportingName={UserReportingName}
                            handleToggleChange={handleToggleChange}
                            handleUserTypeChange={handleUserTypeChange}
                            clearFormValues={clearFormValues}
                            setFormValues={setFormValues}
                            setFormErrors={setFormErrors}
                            loading={loading}
                        />

                        <UserPermission
                            permission={permission}
                            handlePermissionType={handlePermissionType}
                            handleCostingPermission={handleCostingPermission}
                            checkedPermissions={checkedPermissions}
                            formValues={formValues} />

                        <UserSettings
                            permission={permission}
                            handlePermissionType={handlePermissionType}
                            handleCostingPermission={handleCostingPermission}
                            checkedPermissions={checkedPermissions}
                            formValues={formValues}
                            clearFormValues={clearFormValues}
                            handleFormSubmit={handleFormSubmit}
                            isSubmiting={isSubmiting}
                            setPermission={setPermission}
                            setFormValues={setFormValues}
                            setCheckedPermissions={setCheckedPermissions} />
                    </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default UserDetails